import { render, staticRenderFns } from "./MySuggestion.vue?vue&type=template&id=7e073bb4&scoped=true"
import script from "./MySuggestion.vue?vue&type=script&lang=js"
export * from "./MySuggestion.vue?vue&type=script&lang=js"
import style0 from "./MySuggestion.vue?vue&type=style&index=0&id=7e073bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e073bb4",
  null
  
)

export default component.exports